import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Import the CSS module
import styles from './AuthForm.module.css';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
// Optional: Import an icon for the Google button
// import { GoogleIcon } from './icons'; // Assuming you have a Google icon component

function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError("Passwords don't match.");
      return;
    }

    let response; // Declare response outside try block
    try {
      // Use the full URL matching the backend setup
      response = await fetch('http://localhost:3001/api/auth/register', { // <<<<====== UPDATED URL
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password }),
      });

    // --- Improved Error Handling ---
    } catch (err) { // Catches network errors (server down, DNS issues, etc.)
      console.error('Registration Network Error:', err);
      setError('Cannot reach server. Please check your connection or try again later.');
      return; // Stop execution
    }

    // Handle non-OK HTTP responses (like 400, 404, 409, 500)
    if (!response.ok) {
        let errorText = `Error: ${response.status} ${response.statusText}`; // Default error
        try {
          // Attempt to get more specific error message from backend JSON response
          const errorData = await response.json();
          errorText = errorData.error || errorData.message || errorText; // Use backend error if available
        } catch (jsonError) {
           // If the response body wasn't JSON (e.g., the HTML 404 page), log it.
           console.warn("Response was not JSON. Status:", response.status);
           // Keep the default errorText in this case
        }
        setError(errorText);
        return; // Stop execution
    }

    // Only proceed to parse JSON if response.ok is true
    try {
      const data = await response.json(); // Now it's safer to parse
      console.log("Registration Success:", data); // Optional: Log success data
      // Redirect to login with a success message
      navigate('/waitlist-success'); // Changed redirect to waitlist success
    } catch (jsonParseError) {
       // This might happen if the server sends a 2xx status but invalid JSON body
       console.error('Error parsing success JSON:', jsonParseError);
       setError('Received an invalid success response from server.');
    }
  };

   // Placeholder for Google Sign-up logic
   const handleGoogleSignUp = () => {
    console.log('Sign up with Google clicked');
    // Add your Google OAuth logic here
   };

  return (
    // Centering container for the page
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 via-white to-gray-100">
      {/* Apply form container class */}
      <div className={`max-w-md w-full p-8 md:p-10 space-y-8 ${styles.formContainer}`}>
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            {/* Create your ShopEase account */}
            Sign up for Waitlist {/* Changed heading */}
          </h2>
        </div>
        {/* Apply error message class */}
        {error && <div className={`${styles.errorMessage} text-sm`}>{error}</div>}
        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
          <div className="rounded-md -space-y-px">
            {/* Username Field */}
            <div className="pb-4">
              <label htmlFor="username" className={`block text-sm font-medium text-gray-700 mb-1 ${styles.inputLabel}`}>
                Username
              </label>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                required
                className={`relative block w-full appearance-none rounded-md border px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:outline-none sm:text-sm ${styles.inputField}`}
                placeholder="Choose a username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            {/* Email Field */}
            <div className="pb-4">
              <label htmlFor="email-address" className={`block text-sm font-medium text-gray-700 mb-1 ${styles.inputLabel}`}>
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className={`relative block w-full appearance-none rounded-md border px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:outline-none sm:text-sm ${styles.inputField}`}
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {/* Password Field Container */}
            <div className="pb-4"> {/* Keep padding here */}
              <label htmlFor="password" className={`block text-sm font-medium text-gray-700 mb-1 ${styles.inputLabel}`}>
                Password
              </label>
              {/* Wrap input and button in a relative div */}
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="new-password"
                  required
                  // Removed relative, added pr-10
                  className={`block w-full appearance-none rounded-md border px-3 py-2 pr-10 text-gray-900 placeholder-gray-500 focus:z-10 focus:outline-none sm:text-sm ${styles.inputField}`}
                  placeholder="Create a password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                 {/* Button is now positioned relative to the inner div */}
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                   // Removed top-6
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? (
                    <EyeSlashIcon className="h-5 w-5" />
                  ) : (
                    <EyeIcon className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>
            {/* Confirm Password Field Container */}
             <div> {/* Removed pb-4 from this outer div */}
               <label htmlFor="confirm-password" className={`block text-sm font-medium text-gray-700 mb-1 ${styles.inputLabel}`}>
                Confirm Password
              </label>
              {/* Wrap input and button in a relative div */}
              <div className="relative">
                <input
                  id="confirm-password"
                  name="confirm-password"
                  type={showConfirmPassword ? 'text' : 'password'}
                  autoComplete="new-password"
                  required
                   // Removed relative, added pr-10
                  className={`block w-full appearance-none rounded-md border px-3 py-2 pr-10 text-gray-900 placeholder-gray-500 focus:z-10 focus:outline-none sm:text-sm ${styles.inputField}`}
                  placeholder="Confirm your password"
                  value={confirmPassword}
                   onChange={(e) => {
                     setConfirmPassword(e.target.value);
                     if (error === "Passwords don't match.") setError('');
                   }}
                />
                {/* Button is now positioned relative to the inner div */}
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                   // Removed top-6
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                  aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                >
                  {showConfirmPassword ? (
                    <EyeSlashIcon className="h-5 w-5" />
                  ) : (
                    <EyeIcon className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>
          </div>

          <div>
            <button
              type="submit"
              // Apply primary button class alongside Tailwind
              className={`group relative flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-3 px-4 text-sm font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${styles.primaryButton}`}
            >
              {/* Create Account */}
              Join Waitlist {/* Changed button text */}
            </button>
          </div>
        </form>

        {/* Optional: Divider */}
        <div className="relative my-6">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-300/50" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="bg-white/70 px-2 text-gray-500 backdrop-blur-sm rounded-full">Or continue with</span>
          </div>
        </div>

        {/* Google Sign Up Button */}
        <div>
          <button
            type="button"
            onClick={handleGoogleSignUp}
            // Apply secondary button class alongside Tailwind
            className={`${styles.secondaryButton} group relative flex w-full items-center justify-center rounded-md py-3 px-4 text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
          >
            {/* Optional: Add Google Icon */}
            {/* <GoogleIcon className="h-5 w-5 mr-2" /> */}
            {/* Sign up with Google */}
            Join Waitlist with Google {/* Changed Google button text */}
          </button>
        </div>

        <div className="mt-6 text-center text-sm text-gray-500">
          Already have an account?{' '}
           {/* Apply auth link class */}
          <a href="/login" className={`font-medium text-blue-600 hover:text-blue-500 ${styles.authLink}`}>
            Sign In
          </a>
        </div>
      </div>
    </div>
  );
}

export default Register; // Make sure export default is present
